import React, { useEffect } from 'react'
import PropTypes from 'propTypes'

import { LazyImage, Heading } from '@offerzen/pinata-shame'
import { notify } from '@offerzen/react-utils'

import MessageCard from '../../components/MessageCard'
import Content from '../Content'

const CompanyExperienceError = ({ user, error }) => {
  useEffect(() => {
    const safeErrorMessage = error?.message && error.message.trim().split(/\n/g)[0]
    notify('🦙 - user is viewing the drama llama', user, { errorMessage: safeErrorMessage })
  }, [user, error])

  return (
    <Content>
      <MessageCard>
        <LazyImage loader={() => import('../../../assets/llama-blue.svg')} alt="" width={280} />
        <Heading>Woops! We&apos;ve experienced a probllama.</Heading>
      </MessageCard>
    </Content>
  )
}

export default CompanyExperienceError

CompanyExperienceError.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }),
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
}
